import React, { useEffect, useRef, useState } from "react";
import FrontendLayout from "../../layouts/FrontendLayout";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL, fetchData } from "../../api/api";
import PracticeCardMap from "../../components/frontend/practices/PracticeCardMap";
import Spinner from "../../components/common/Spinner";
import Select from "react-select";
import { extractSlugDetails } from "../../utils/slug";
import { BASEURL, ORDERBY_FIELDS_LIST } from "../../constant/common";
import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import { getInitials, getPracticeMapUrl } from "../../utils/helper";
import { StarRating } from "../../components/common/StarRating";
import { toast } from "react-toastify";
import CompareModal from "../../components/frontend/filter/CompareModal";
import InquiryEmailSend from "../../components/frontend/enquiry/InquiryEmailSend";
import { Helmet } from "react-helmet-async";

const containerStyle = {
    width: "100%",
    height: "100%",
};

const MapPage = () => {
  const location = useLocation();
  const canonicalUrl = `${BASEURL}${location.pathname}`;

    const [selectedPractice, setSelectedPractice] = useState(null);

    const { postcode, slug } = useParams();

    const { services, suburb } = extractSlugDetails(slug);

    const didFetch = useRef(false);

    const [searchList, setSearchList] = useState([]);

    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [selectedPaymentMethods, setSelectedPaymentMethods] = useState([]);
    const [selectedOrderBy, setSelectedOrderBy] = useState(null);

    const [postcodeData, setPostcodeData] = useState(null);
    const [suburbData, setSuburbData] = useState(null);
    const [serviceData, setServiceData] = useState(null);

    const [selectedComparisons, setSelectedComparisons] = useState([]);

    const [isCompareModal, setIsCompareModal] = useState(false);

    const [isInquiryEmailSend, setIsInquiryEmailSend] = useState(false);

    const isSelected = selectedComparisons.some((compareItem) => compareItem.practices_id === selectedPractice?.practices_id);

    const handleCompareChange = () => {
        if (isSelected) {
            setSelectedComparisons((prev) =>
                prev.filter((compareItem) => compareItem.practices_id !== selectedPractice.practices_id)
            );
        } else {
            if (selectedComparisons.length < 3) {
                setSelectedComparisons((prev) => [...prev, selectedPractice]);
            }
            else {
                toast.error("You can only compare up to 3 items.");
            }
        }
    };

    const center = { lat: suburbData?.latitude ? Number(suburbData?.latitude) : 135.0000, lng: suburbData?.longitude ? Number(suburbData?.longitude) : 25.0000 };

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const totalPages = Math.ceil(searchList.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const paginatedData = searchList?.length > 0 ? searchList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    ) : [];

    const [isLoading, setIsLoading] = useState(false);

    const [selectedFilter, setSelectedFilter] = useState("All");

    const [paymentMethodsList, setPaymentMethodsList] = useState([]);

    const [languagesList, setLanguagesList] = useState([]);

    const getSearchList = async (tab) => {
        setIsLoading(true);
        let is_practitioner = null;
        if (tab == "Practitioners") {
            is_practitioner = 1;
        }
        else if (tab == "Practices") {
            is_practitioner = 0;
        }
        else {
            is_practitioner = null;
        }

        try {
            const data = await fetchData('/get-frontend-practices', {
                status: 1,
                is_practitioner: is_practitioner,
                languages_ids: selectedLanguages.join(","),
                payment_methods_ids: selectedPaymentMethods.join(","),
                services: services,
                postcode: postcode,
                suburb: suburb,
                order_by: selectedOrderBy?.value,
                near_by_suburb: true,
            });
            setSearchList(data?.practices ? data?.practices : []);
            setPostcodeData(data?.postcode ? data?.postcode : null);
            setSuburbData(data?.suburb ? data?.suburb : null);
            setServiceData(data?.services ? data?.services : null);

            setSelectedPractice(null)

            setSelectedComparisons([]);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getSearchList(null);
            didFetch.current = true;
            didFetch.filter = false;
        }
    }, []);

    useEffect(() => {
        if (didFetch.filter) {
            getSearchList(selectedFilter);
        }
    }, [selectedOrderBy]);

    useEffect(() => {
        if (selectedComparisons?.length === 0) {
            setIsCompareModal(false);
        }
    }, [selectedComparisons]);

    const handleTabChange = (tab) => {
        setSelectedFilter(tab)
        setCurrentPage(1);
        getSearchList(tab);
    }

    const handleOnClickClearAll = () => {
        setSelectedLanguages([]);
        setSelectedPaymentMethods([]);
    };

    const filteredSearchList = searchList
        .filter((item) =>
            selectedComparisons.some((compareItem) => compareItem.practices_id === item?.practices_id)
        )
        .sort(
            (a, b) =>
                selectedComparisons.findIndex((compareItem) => compareItem.practices_id === a.practices_id) -
                selectedComparisons.findIndex((compareItem) => compareItem.practices_id === b.practices_id)
        );

    const handleOrderByChange = (selectedOption) => {
        didFetch.filter = true;
        setSelectedOrderBy(selectedOption);
    };

    if (isLoading) {
        return (<Spinner />);
    }

    return (
        <>
              <Helmet>
                <link rel="canonical" href={canonicalUrl} />
              </Helmet>
            <FrontendLayout>


                <section>
                    <div className="lg:h-[calc(100vh-96px)] flex flex-wrap">

                        <div className="w-full lg:w-[615px] h-full bg-white sm:px-10 px-4 py-6 order-2 lg:order-1 -mt-4 rounded-t-xl">
                            <div>
                                <div className="flex flex-row justify-between items-center gap-0 mb-4 md:mb-6 bg-white rounded">
                                    <button
                                        onClick={() => handleTabChange("All")}
                                        className={`text-base sm:text-xl py-2  ${selectedFilter === "All" ? "text-blue font-bold" : "text-dark font-medium"
                                            }`}>
                                        All
                                    </button>
                                    <button
                                        onClick={() => handleTabChange("Practitioners")}
                                        className={`text-base sm:text-xl py-2  ${selectedFilter === "Practitioners" ? "text-blue font-bold" : "text-dark font-medium"
                                            }`}>
                                        Practitioners
                                    </button>
                                    <button
                                        onClick={() => handleTabChange("Practices")}
                                        className={`text-base sm:text-xl py-2  ${selectedFilter === "Practices" ? "text-blue font-bold" : "text-dark font-medium"
                                            }`}>
                                        Practices
                                    </button>
                                </div>
                                <div className="flex gap-4 flex-wrap">

                                    <div className="dropdown">
                                        <Select
                                            options={ORDERBY_FIELDS_LIST.map((item) => ({
                                                value: item.value,
                                                label: item.name
                                            }))}
                                            className="text-black custom-sortby-select"
                                            placeholder="Sort By"
                                            value={selectedOrderBy}
                                            onChange={handleOrderByChange}
                                            isClearable
                                        />
                                    </div>
                                    <Link to={`/${postcode}/${slug}`} className="px-5 lg:px-7 py-1.5 bg-transparent text-dark border border-dark text-xs font-bold rounded border-solid flex items-center justify-center">List
                                    </Link>
                                    <div className="px-5 lg:px-7 py-1.5 bg-blue text-white border border-blue text-xs font-bold rounded border-solid flex items-center justify-center">Map
                                    </div>

                                </div>
                            </div>
                            <div className="h-[calc(100%-85px)] overflow-y-auto -mx-4 sm:-mx-10 mt-4 no-scrollbar">
                                <div>
                                    {paginatedData?.length > 0 ? paginatedData?.map((item, index) => (
                                        <PracticeCardMap key={index} item={item} postcode={postcode} slug={slug} setSelectedPractice={setSelectedPractice} selectedPractice={selectedPractice} />
                                    ))
                                        :
                                        <p className="text-center my-2">No practices found.</p>}
                                </div>

                                {paginatedData?.length > 0 && (
                                    <div className="px-3 py-3 border-t-0 border-solid border-[#dfdfdf]">
                                        <ul className="flex items-center -space-x-px h-10 text-base justify-end">
                                            {/* Previous Button */}
                                            <li>
                                                <button
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                    className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${currentPage === 1 ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                                >
                                                    <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"></path>
                                                    </svg>
                                                </button>
                                            </li>

                                            {/* Dynamic Pagination Logic */}
                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter((page) => {
                                                    return (
                                                        page === 1 ||
                                                        page === totalPages ||
                                                        (page >= currentPage - 1 && page <= currentPage + 1)
                                                    );
                                                })
                                                .reduce((acc, page, index, arr) => {
                                                    if (index > 0 && page !== arr[index - 1] + 1) {
                                                        acc.push("...");
                                                    }
                                                    acc.push(page);
                                                    return acc;
                                                }, [])
                                                .map((page, index) => (
                                                    <li key={index}>
                                                        {page === "..." ? (
                                                            <span className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}>...</span>
                                                        ) : (
                                                            <button
                                                                onClick={() => handlePageChange(page)}
                                                                className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${currentPage === page ? "bg-white text-blue" : "bg-gray-200 text-blue hover:bg-gray-100"}`}
                                                            >
                                                                {page}
                                                            </button>
                                                        )}
                                                    </li>
                                                ))}

                                            {/* Next Button */}
                                            <li>
                                                <button
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                    className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${currentPage === totalPages ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                                >
                                                    <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"></path>
                                                    </svg>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>

                        </div>
                        <div className="w-full h-[60vh] lg:h-full lg:w-[calc(100%-615px)] order-1 lg:order-2">
                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={center}
                                zoom={15}
                                options={{
                                    styles: [
                                        {
                                            featureType: "poi",
                                            elementType: "all",
                                            stylers: [{ visibility: "off" }],
                                        },
                                    ],
                                }}
                            >
                                {searchList?.map((practice) =>
                                    practice.latitude && practice.longitude ? (
                                        <Marker
                                            key={practice.practices_id}
                                            position={{ lat: parseFloat(practice.latitude), lng: parseFloat(practice.longitude) }}
                                            onClick={() => setSelectedPractice(practice)}
                                        />
                                    ) : null
                                )}

                                {selectedPractice && (
                                    <InfoWindow
                                        position={{
                                            lat: parseFloat(selectedPractice.latitude),
                                            lng: parseFloat(selectedPractice.longitude),
                                        }}
                                        onCloseClick={() => setSelectedPractice(null)}
                                        options={{ pixelOffset: new window.google.maps.Size(0, -30) }}
                                    >
                                        <div className="max-w-lg min-w-64">
                                            <div className="w-full flex flex-wrap gap-y-3 listcardwrapper">
                                                <div className="w-[100px] sm:w-[140px] imgcard-google-map">
                                                    <Link
                                                        // to={selectedPractice.is_practitioner === 0 ? `/${postcode}/${slug}/${selectedPractice?.slug}` : `/${postcode}/${slug}/${selectedPractice?.practice?.slug}/${selectedPractice?.slug}`}
                                                        to={selectedPractice.is_practitioner === 0 ? 
                                                            `/${selectedPractice?.postcode?.postcode}/${services}-in-${selectedPractice?.suburb?.slug}/${selectedPractice?.slug}` : 
                                                            `/${selectedPractice?.postcode?.postcode}/${services}-in-${selectedPractice?.suburb?.slug}/${selectedPractice?.practice?.slug}/${selectedPractice?.slug}`
                                                        }
                                                        target="_blank" rel="noopener noreferrer"
                                                        className="cursor-pointer focus:border-none"                        >

                                                        {selectedPractice?.image ? (
                                                            <img src={selectedPractice.image ? API_BASE_URL + selectedPractice.image : null} alt="" className="w-full rounded-lg aspect-square object-cover" />
                                                        ) : (
                                                            <div className="w-full rounded-lg aspect-square object-cover mb-1.5 bg-gray-200 flex items-center justify-center text-5xl overflow-hidden font-semibold text-gray-700">
                                                                {selectedPractice?.practice_name && getInitials(selectedPractice?.practice_name)}
                                                            </div>
                                                        )}
                                                    </Link>
                                                </div>
                                                <div className="w-[calc(100%-100px)] sm:w-[calc(100%-140px)] pl-3 sm:pl-6 contentcard">
                                                    <div className="">
                                                        <Link
                                                            // to={selectedPractice.is_practitioner === 0 ? `/${postcode}/${slug}/${selectedPractice?.slug}` : `/${postcode}/${slug}/${selectedPractice?.practice?.slug}/${selectedPractice?.slug}`}
                                                            to={selectedPractice.is_practitioner === 0 ? 
                                                                `/${selectedPractice?.postcode?.postcode}/${services}-in-${selectedPractice?.suburb?.slug}/${selectedPractice?.slug}` : 
                                                                `/${selectedPractice?.postcode?.postcode}/${services}-in-${selectedPractice?.suburb?.slug}/${selectedPractice?.practice?.slug}/${selectedPractice?.slug}`
                                                            }
                                                            target="_blank" rel="noopener noreferrer"
                                                            className="text-base sm:text-lg block w-fit font-semibold text-gray-800 mb-1 sm:mb-2 cursor-pointer">
                                                            <span>{selectedPractice?.practice_name}</span>
                                                            {selectedPractice?.is_verified == 1
                                                                &&
                                                                <span className="float-right mt-1 pl-2">
                                                                    <img src="/assets/image/verifiedicon.svg" alt="" srcSet="" />
                                                                </span>
                                                            }
                                                        </Link>

                                                        {selectedPractice?.address &&
                                                            <Link
                                                                to={getPracticeMapUrl(selectedPractice)}
                                                                target="_blank" rel="noopener noreferrer"
                                                                className="flex gap-x-2  gap-y-1 sm:items-center mb-2 sm:mb-3">
                                                                <svg width="24" className="w-5 h-5 mt-1 sm:mt-0" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z" fill="#0052CC" />
                                                                </svg>
                                                                <span className="text-dark text-xs font-medium underline underline-offset-[2px] w-[calc(100%-24px)] sm:w-[calc(100%-36px)]">{selectedPractice?.address}, {selectedPractice?.suburb?.name} {selectedPractice?.state?.name} {selectedPractice?.postcode?.postcode}</span>
                                                            </Link>
                                                        }
                                                        <input
                                                            type="checkbox"
                                                            id={`compare_${selectedPractice.practices_id}`}
                                                            className="hidden peer"
                                                            checked={isSelected}
                                                            onChange={handleCompareChange}
                                                        // disabled={!isSelected && selectedComparisons.length >= 3}
                                                        />
                                                        <label
                                                            htmlFor={`compare_${selectedPractice.practices_id}`}
                                                            className={`cursor-pointer bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 flex items-center justify-center border border-dark peer-checked:bg-green peer-checked:text-white peer-checked:border-green gap-x-3`}
                                                        >
                                                            <div className="h-4 w-4 border border-dark rounded peer-checked:bg-white peer-checked:border-green flex items-center justify-center">
                                                                {isSelected && (
                                                                    <div className="checkicon">
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M16 1.83337C16 0.822021 15.178 0 14.1666 0H1.83337C0.822021 0 0 0.822021 0 1.83337V14.1666C0 15.178 0.822021 16 1.83337 16H14.1666C15.178 16 16 15.178 16 14.1666V1.83337Z" fill="white"></path>
                                                                            <path d="M13.7255 4.27607C14.0915 4.64399 14.0915 5.2387 13.7255 5.60679L7.64061 11.7241C7.45806 11.9076 7.21842 12 6.97879 12C6.73916 12 6.49953 11.9076 6.31697 11.7241L3.2746 8.66545C2.90847 8.29753 2.90847 7.70265 3.2746 7.33473C3.64056 6.96663 4.2321 6.96663 4.59824 7.33473L6.97879 9.72802L12.4019 4.27607C12.7679 3.90798 13.3594 3.90798 13.7255 4.27607Z" fill="#00A167"></path>
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <span>{isSelected ? "Remove" : "Compare"}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </InfoWindow>
                                )}
                            </GoogleMap>
                        </div>
                    </div>


                    <div id="bottomSheet" class={`fixed  bottom-0 left-0 w-full bg-white border-t border-gray-300 shadow-lg px-4 py-3 items-center justify-center gap-4 z-50 ${selectedComparisons?.length > 0 ? 'flex' : 'hidden'}`}>
                        <div className="flex flex-wrap items-center space-x-4">
                            {filteredSearchList?.length > 0 ? (
                                filteredSearchList?.map((item) => (
                                    <div
                                        key={item.practices_id}
                                        className="border rounded-lg flex items-center justify-center bg-white relative gap-3 p-1"
                                    >
                                        {item.image ? (
                                            <img
                                                src={item.image ? API_BASE_URL + item.image : null}
                                                alt="Item 1"
                                                className="object-cover rounded-lg w-10 aspect-square" />

                                        ) : (
                                            <div className="bg-gray-200 text-gray-700 font-semibold flex items-center justify-center rounded-lg w-10 aspect-square overflow-hidden">
                                                <p className="text-sm">
                                                    {item?.practice_name && getInitials(item?.practice_name)}
                                                </p>
                                            </div>
                                        )}
                                        <button className="text-sm font-bold"
                                            onClick={() => setSelectedComparisons((prev) => prev.filter(compareItem => compareItem.practices_id !== item.practices_id))}
                                        >
                                            <svg
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                                            </svg>
                                        </button>
                                    </div>
                                ))
                            ) : null
                            }

                            {filteredSearchList?.length < 3 &&
                                <div className="flex items-center justify-center h-full p-2 border border-dashed border-gray-400 rounded-lg">
                                    <div className="text-gray-500">Add {3 - filteredSearchList.length} more</div>
                                </div>
                            }
                            <button
                                type="button"
                                onClick={() => setIsCompareModal(true)}
                                className="bg-blue text-white py-2 px-4 rounded-lg shadow-md h-full comparebtn">Compare</button>
                            <button
                                type="button"
                                onClick={() => setSelectedComparisons([])}
                                className="text-dark border border-gray-300 py-2 px-4 rounded-lg  h-full">Clear</button>
                        </div>
                    </div>

                    <div id="comparepopup" class={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${isCompareModal ? 'flex' : 'hidden'}`}>
                        <CompareModal setIsCompareModal={setIsCompareModal} items={filteredSearchList} setSelectedComparisons={setSelectedComparisons}
                            postcode={postcode}
                            slug={slug}
                            services={services}
                            suburb={suburb}
                            setIsInquiryEmailSend={setIsInquiryEmailSend}
                            setSelectedPractice={setSelectedPractice}
                        />
                    </div>

                </section>


                <InquiryEmailSend
                    isInquiryEmailSend={isInquiryEmailSend}
                    setIsInquiryEmailSend={setIsInquiryEmailSend}
                    practices_id={selectedPractice?.practices_id}
                    setSelectedPractice={setSelectedPractice}
                    goToHomeUrl={'/'}
                />
            </FrontendLayout>
        </>)
}

export default MapPage